import AvatarBlocked from "./avatar-blocked";

export default AvatarBlocked;